// extracted by mini-css-extract-plugin
export default {"tableStyle":"Table_tableStyle__UzHCM","thStyle":"Table_thStyle__Cfq14"};